export default "__VITE_ASSET__CFA1nCD6__"